"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSpinners = require("react-spinners");
require("./Spinner.scss");
var Spinner = function Spinner(_ref) {
  var isLoading = _ref.isLoading;
  return isLoading && _react.default.createElement("div", {
    className: "spinner"
  }, _react.default.createElement("div", {
    className: "spinner-inner-content"
  }, _react.default.createElement(_reactSpinners.ClipLoader, {
    sizeUnit: "px",
    size: 64,
    color: "#fff",
    loading: isLoading
  })));
};
Spinner.defaultProps = {
  isLoading: false
};
var _default = Spinner;
exports.default = _default;
module.exports = exports["default"];